export enum MapCalculationMode {
  ISOLATED = 'isolated',
  MERGED = 'merged'
}
